import type { JSX } from 'react';
import { SplitViewTrigger } from '@ksyos/design-system';
import { styled } from 'styled-components';
import { useSplitViewContext } from '@frontend/utils/hooks/useSplitViewContext';

export function SplitViewTriggerWrapper(): JSX.Element | null {
    const { isSplitViewAvailable, isSplitViewOpen, setIsSplitViewOpenWhenAvailable, splitViewContent } =
        useSplitViewContext();

    if (!isSplitViewAvailable || !splitViewContent) {
        return null;
    }

    return (
        <StyledSplitViewTriggerWrapper>
            <SplitViewTrigger
                icon="todo-list"
                isSplitViewOpen={isSplitViewOpen}
                labelTextClose="Verberg taken en acties"
                labelTextOpen="Toon taken en acties"
                onClick={() => setIsSplitViewOpenWhenAvailable((currentValue) => !currentValue)}
            />
        </StyledSplitViewTriggerWrapper>
    );
}

const StyledSplitViewTriggerWrapper = styled.div`
    display: none;
    flex: 1 0 auto;
    justify-content: end;
    padding-bottom: ${({ theme }) => theme.space[3]};
    border-bottom: 1px solid ${({ theme }) => theme.colors.neutral300};

    &:only-child {
        border-bottom: none;
        position: absolute;
        right: 0;
    }

    ${({ theme }) => theme.mediaQueries.xlarge} {
        display: flex;
    }
`;
